import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "title mb-2" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "button-header text-lg-right upload-btn-wrap" }
const _hoisted_7 = {
  href: "javascript:void(0)",
  class: "btn default-btn d-inline-block",
  id: "uploadPdfForDigitize"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_9 = {
  class: "card p-0",
  id: "uploadedPdfTemplate"
}
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table mb-0 table-shadowed" }
const _hoisted_12 = { class: "table-primary text-nowrap" }
const _hoisted_13 = { scope: "col" }
const _hoisted_14 = { scope: "col" }
const _hoisted_15 = { scope: "col" }
const _hoisted_16 = { scope: "col" }
const _hoisted_17 = { scope: "col" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt mx-2" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "user-card"
}
const _hoisted_21 = { class: "user-img-wrap" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "badge badge-alert" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "badge badge-alert" }
const _hoisted_26 = { class: "table-button" }
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { colspan: "5" }
const _hoisted_32 = { class: "modal-wrap" }
const _hoisted_33 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_35 = { class: "modal-content  mh-auto" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_39 = { class: "modal-body" }
const _hoisted_40 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = { class: "modal-wrap" }
const _hoisted_45 = {
  class: "modal fade",
  id: "deleteConfirmeModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_47 = { class: "modal-content  mh-auto" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }, null, -1)
const _hoisted_54 = { class: "modal-footer" }
const _hoisted_55 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('upload_pdf_for_digitization')), 1),
          _createVNode("p", null, [
            _createVNode("small", null, _toDisplayString(_ctx.$t('beta_thank_you_message')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("a", _hoisted_7, [
              _createVNode("input", {
                type: "file",
                accept: "application/pdf",
                multiple: "",
                id: "pdf-digitize",
                class: "custom-file-input",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDocumentChange($event)))
              }, null, 32),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.state.ui.isPostLoading.uploadClientDocument ? _ctx.$t('uploading'):_ctx.$t('upload_pdf_templates')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("table", _hoisted_11, [
          _createVNode("thead", _hoisted_12, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('upload_template')), 1),
              _createVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('uploaded_by')), 1),
              _createVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('uploaded_date')), 1),
              _createVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('current_status')), 1),
              _createVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('action')), 1)
            ])
          ]),
          (
              _ctx.state.data.clientDocuments && _ctx.state.data.clientDocuments.length
            )
            ? (_openBlock(), _createBlock("tbody", _hoisted_18, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.clientDocuments, (document, documentIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                    _createVNode("td", null, [
                      _createVNode("p", null, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.openPdf(document.file_path))
                        }, [
                          _createTextVNode(_toDisplayString(document.name) + " ", 1),
                          _hoisted_19
                        ], 8, ["onClick"]),
                        _createVNode("small", null, [
                          _createVNode("i", null, "(" + _toDisplayString(document.convertedFileSize) + ")", 1)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      (document.client && document.client.email)
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode("span", _hoisted_21, [
                              (document.client.image)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: document.client.image,
                                    alt: ""
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    src: 
                        _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/avatar-1.jpg`
                          : 'img/avatar-1.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"]))
                            ]),
                            _createTextVNode(" " + _toDisplayString(document.client.full_name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("p", null, _toDisplayString(document.created_at), 1)
                    ]),
                    _createVNode("td", null, [
                      (document.status && document.status.code === 'ready')
                        ? (_openBlock(), _createBlock("p", _hoisted_22, [
                            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('ready')), 1)
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_24, [
                            _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('pending')), 1)
                          ]))
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_26, [
                        (document.status && document.is_enabled != 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0)",
                              class: "btn enable-btn mr-1",
                              onClick: ($event: any) => (_ctx.enableDocument(document))
                            }, [
                              _hoisted_27,
                              _createTextVNode(" " + _toDisplayString(document.enableStatus ? _ctx.$t('in_progress') : _ctx.$t('enable')), 1)
                            ], 8, ["onClick"]))
                          : (_openBlock(), _createBlock("a", {
                              key: 1,
                              href: "javascript:void(0)",
                              class: "btn disable-btn mr-1",
                              onClick: ($event: any) => (_ctx.disableDocument(document))
                            }, [
                              _hoisted_28,
                              _createTextVNode(" " + _toDisplayString(document.disableStatus ? _ctx.$t('in_progress') : _ctx.$t('disable')), 1)
                            ], 8, ["onClick"])),
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn delete-btn mr-1",
                          onClick: ($event: any) => (_ctx.showDeleteModal(document))
                        }, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(document.deleteStatus ? _ctx.$t('in_progress') : _ctx.$t('delete')), 1)
                        ], 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_30, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_31, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              (
                  _ctx.state.data.clientDocuments &&
                    _ctx.state.data.clientDocuments.length
                )
                ? (_openBlock(), _createBlock("h5", _hoisted_37, _toDisplayString(_ctx.state.data.clientDocuments[0].file_name), 1))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_38
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _hoisted_42,
                _createVNode("strong", null, _toDisplayString(_ctx.$t('successfully_uploaded_pdf')) + ".", 1),
                _createVNode("p", null, [
                  _createVNode("small", null, _toDisplayString(_ctx.$t('beta_thank_you_message')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_44, [
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("h5", _hoisted_49, _toDisplayString(_ctx.$t('delete_confirm')), 1),
              _hoisted_50
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _hoisted_53,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete_confirmation')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteDocument && _ctx.deleteDocument(...args)))
              }, _toDisplayString(_ctx.$t('yes')), 1),
              _createVNode("button", _hoisted_55, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}